import React from 'react';

const UnderlyingPriceTrailDocs = (
  <>
    <p>
      This tactic sets a trail on the underlying stock. As the trade moves in
      the direction of the tradePlan (long/short), the trail adjusts in that
      direction.
    </p>
    <p>
      Ex: Let&apos;s say AAPL is at 449.75, and you want to buy on a break of 450.
      Once AAPL loses momentum though, you would want to sell it. This tactic
      could accomplish that goal. You would set a trail of let&apos;s say 25 cents on
      AAPL. As the stock continues to go higher, the trail adjusts higher with
      it, so that if AAPL hits 450.5, the trail, which originally was at around
      449.75 (break price of 450-.25), will now adjust to 450.25. Once AAPL hits
      450.25, the position would flatten.
    </p>
    <p>
      NOTE: The main use of this tactic is if you are trading options, but want
      to have a trail set on the underlying, and not the position.
    </p>
  </>
);

export default UnderlyingPriceTrailDocs;
